import {
    SET_PROPM_LOCKBOX_INFO,
    SET_PROPM_INSPECTION,
    SET_PROPM_MAINTENACE_REPAIR,
    SET_PROPM_VIOLATIONS,
    SET_PROPM_UTILITY_VENDOR_REFERENCE
} from '../../types';

const initialState = {
    LockboxInfo: [],
    InspectionData: [],
    MaintenaceAndRepair: [],
    PropMViolations: [],
    UtilityVendorReference: [],
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PROPM_LOCKBOX_INFO:
            return {
                ...state,
                LockboxInfo: [...payload]
            };
        case SET_PROPM_INSPECTION:
            return {
                ...state,
                InspectionData: [...payload]
            };
        case SET_PROPM_MAINTENACE_REPAIR:
            return {
                ...state,
                MaintenaceAndRepair: [...payload]
            };
        case SET_PROPM_VIOLATIONS:
            return {
                ...state,
                PropMViolations: [...payload]
            };
        case SET_PROPM_UTILITY_VENDOR_REFERENCE:
            return {
                ...state,
                UtilityVendorReference: [...payload]
            };
        default:
            return state;
    }
}
